var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZakonczone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.13 132.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.41,14.33c-.14-.53-.61-.89-1.16-.89h-7.03c-.54,0-1.02.37-1.16.89l-7.27,27.77c-.17.64.22,1.29.86,1.46.64.16,1.29-.22,1.46-.86l2.02-7.73h15.21l2.02,7.73c.14.54.63.89,1.16.89.1,0,.2-.01.3-.04.64-.17,1.02-.82.86-1.46l-7.27-27.77ZM21.76,32.59l4.39-16.75h5.18l4.39,16.75h-13.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,57.68h-44.76c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2h44.76c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.72,71.83h25.54c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2h-25.54c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,87.23h-44.76c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2h44.76c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,98.98h-25.54c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2h25.54c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78,24.43L83.69.35c-.21-.21-.55-.35-.85-.35H7.35C3.3,0,0,3.3,0,7.35v117.72c0,4.06,3.3,7.35,7.35,7.35h93.42c4.06,0,7.35-3.3,7.35-7.35V25.28c0-.25-.14-.63-.35-.85ZM84.04,4.09l20,20h-20V4.09ZM100.77,130.03H7.35c-2.74,0-4.96-2.22-4.96-4.96V7.35c0-2.74,2.22-4.96,4.96-4.96h74.29v22.89c0,.66.54,1.2,1.2,1.2h22.89v98.59c0,2.74-2.22,4.96-4.96,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.15,29.72h3.68v3.68c0,.66.54,1.2,1.2,1.2s1.2-.54,1.2-1.2v-3.68h3.68c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2h-3.68v-3.68c0-.66-.54-1.2-1.2-1.2s-1.2.54-1.2,1.2v3.68h-3.68c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,55.99h-15.15c-.66,0-1.2.54-1.2,1.2v15.15c0,.66.54,1.2,1.2,1.2h15.15c.66,0,1.2-.54,1.2-1.2v-15.15c0-.66-.54-1.2-1.2-1.2ZM31.9,71.13h-12.75v-12.75h12.75v12.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,85.53h-15.15c-.66,0-1.2.54-1.2,1.2v15.15c0,.66.54,1.2,1.2,1.2h15.15c.66,0,1.2-.54,1.2-1.2v-15.15c0-.66-.54-1.2-1.2-1.2ZM31.9,100.68h-12.75v-12.75h12.75v12.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZakonczone);
export default __webpack_public_path__ + "static/media/zakonczone.acbc1aed9d99d4a1c6564dc2b676139e.svg";
export { ForwardRef as ReactComponent };